// extracted by mini-css-extract-plugin
export var brand = "_2u-9";
export var compact = "_2u-6";
export var extraSmall = "_2u-7";
export var icon = "_2u-0";
export var large = "_2u-4";
export var light = "_2u-1";
export var medium = "_2u-5";
export var outline = "_2u-b";
export var primaryDark = "_2u-a";
export var primaryLight = "_2u-8";
export var primaryModern = "_2u-c";
export var success = "_2u-2";
export var successSolid = "_2u-3";